var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"shop"},[_c('h2',{staticClass:"name"},[_vm._v(_vm._s(_vm.shop.restaurant.name))]),_vm._v(" "),_c('member-list',{attrs:{"members":_vm.shop.members}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1112814","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/groupingResult/shop.vue
// module id = null
// module chunks = 